import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { useAnimatedNumber } from '../../hooks/use-animated-number.hook';
import { formatAnimatedNumber, FormatAnimatedNumberOptions } from './format-animated-number.util';

export type AnimatedNumberProps = {
  className?: string;
  duration?: number;
  emptyDisplay?: string;
  value: number;
} & FormatAnimatedNumberOptions;

export const AnimatedNumber: FC<AnimatedNumberProps> = ({
  className,
  duration,
  emptyDisplay,
  value,
  ...formatOptions
}) => {
  const animatedValue = useAnimatedNumber(value, { duration });
  const emptyThreshold = formatOptions.integer ? 0.5 : Number.EPSILON;
  const showEmpty =
    emptyDisplay !== undefined &&
    Math.abs(value) < Number.EPSILON &&
    Math.abs(animatedValue) < emptyThreshold;

  return (
    <span className={twMerge('tabular-nums', className)}>
      {showEmpty ? emptyDisplay : formatAnimatedNumber(animatedValue, formatOptions)}
    </span>
  );
};
